import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { Card, Flex } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useGetCommissionsBatch } from "../../../../common/api/queries";
import BackNavigationArrow from "../../../../common/components/views/BackNavigationArrow";
import { EntityIdObject } from "../../../../common/types";
import { DEFAULT_POSTPONED_COMMISSIONS_QUERY_PARAMS } from "../../postponed/api";
import { PostponedCommissionsReport } from "../../postponed/enums";
import { PostponedCommissionsFilterPageRequest } from "../../postponed/types";
import { BatchPostponedCommissionFilterForm } from "../components/forms/filter/BatchPostponedCommissionFilterForm";
import { BatchCommissionsTable } from "../components/tables/BatchCommissionsTable";

export const CommissionsBatchPostponedCommissionsContainer = () => {
  const { t } = useTranslation();

  const { id } = useParams<EntityIdObject>() as { id: string };

  const { data: batch, isError } = useGetCommissionsBatch(id);

  const searchParams = useFilterSearchParams<PostponedCommissionsFilterPageRequest>({
    params: ["report", "postponementReasons", "institutionIds"],
    defaultQueryParamsObject: {
      ...DEFAULT_POSTPONED_COMMISSIONS_QUERY_PARAMS,
      report: PostponedCommissionsReport.UNRESOLVED_INCLUDED_IN_BATCH,
    },
  });

  const report = searchParams.report ?? PostponedCommissionsReport.UNRESOLVED_INCLUDED_IN_BATCH;

  return (
    <DisplayWrapper itemLoaded={!!batch} isError={isError}>
      {batch ? (
        <>
          <Card
            className="card-box"
            title={
              <BackNavigationArrow>
                <h2>{t("commissions.batch.titles.managePreviousBatchesCommissions")}</h2>
                <span className="sub-header-info normal-font-size">
                  {t("commissions.batch.titles.batchDetail", { name: batch.name })}
                </span>
              </BackNavigationArrow>
            }
          >
            <Flex justify="center">
              <BatchPostponedCommissionFilterForm searchParams={searchParams} batch={batch} />
            </Flex>
          </Card>

          <Card className="card-box">
            <BatchCommissionsTable
              batch={batch}
              viewType="postponed"
              commissionFormType="duplicatedCommission"
              filterData={{
                ...searchParams,
                batchId: report === PostponedCommissionsReport.UNRESOLVED_INCLUDED_IN_BATCH ? id : undefined,
                report,
              }}
            />
          </Card>
        </>
      ) : undefined}
    </DisplayWrapper>
  );
};
